import React from 'react';

import { Box } from '../../../components/Box/Box';
import { FileSystem } from '../../../components/FileSystem/FileSystem';
import { SharedFileSystemProps } from '../../../types/SharedFileSystemProps';

export const FileSystemCell = ({
  onClick,
  ...props
}: SharedFileSystemProps) => {
  return (
    <Box onClick={onClick} minW={0}>
      <FileSystem {...props} />
    </Box>
  );
};
